module.exports = __webpack_public_path__ + "static/media/work_permit.86b866e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/meet_and_greet/work_permit.jpg
// module id = 169
// module chunks = 0 2